const bindingKeys = ['filename_source', 'display_title_source', 'main_text_source'];

export function typeFormValues(type) {
    return {...type, linked_group_ids: (type.custom_meta_groups || []).map(entry => entry.custom_meta_group.id), display_config: {
        main_text_editable: type.main_text_editable,
        ...Object.fromEntries(bindingKeys.map(key => [key, 'input'])),
        ...type.display_config
    }};
}

export function typeGroupAttributes(type, ids) {
    const selected = new Set(ids.map(Number));
    const existing = type.custom_meta_groups || [];
    return [
        ...existing.filter(entry => !selected.has(entry.custom_meta_group.id)).map(entry => ({id: entry.id, _destroy: true})),
        ...ids.map((id, index) => ({id: existing.find(entry => entry.custom_meta_group.id === Number(id))?.id,
            custom_meta_group_id: Number(id), position: index + 1}))
    ];
}

export function mergeTypeDisplayConfig(type, edits) {
    const original = type.display_config || {};
    const config = {...original, ...edits};
    const hints = {...original.import_sources};
    for (const key of bindingKeys) {
        config[key] = config[key] || 'input';
        if (config[key] !== (original[key] || 'input')) delete hints[key];
    }
    if (original.import_sources) config.import_sources = hints;
    return config;
}
